module.exports = __webpack_public_path__ + "static/img/img_cabinet.afb016aa.png";